module.exports = __webpack_public_path__ + "static/img/图层6.a51636f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2019_firefly_TerWeb/4/图层6.png
// module id = kBBG
// module chunks = 1